import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TestimonialModalService {

  private selectedTestimonialSubject = new BehaviorSubject<any>(null);
  public selectedTestimonial$ = this.selectedTestimonialSubject.asObservable();

  constructor() { }

  setSelectedTestimonial(testimonial: any): void {
    this.selectedTestimonialSubject.next(testimonial);
  }

  getSelectedTestimonial(): any | null {
    return this.selectedTestimonialSubject.value;
  }

  clearSelectedTestimonial(): void {
    this.selectedTestimonialSubject.next(null);
  }
}

